var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: " ",
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.close($event)
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: " ",
          on: {
            dragover: function($event) {
              $event.preventDefault()
            },
            drop: function($event) {
              $event.preventDefault()
              return _vm.handleDrop($event)
            }
          }
        },
        [
          _c("div", { staticClass: "drop-area", on: { click: _vm.openFile } }, [
            _vm._v("\n      Paste (Ctrl+V), Drop Image, atau Klik\n    ")
          ]),
          _vm._v(" "),
          _vm.limit
            ? _c("p", [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.value.length) +
                    " / " +
                    _vm._s(_vm.limit) +
                    " gambar\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            ref: "file",
            attrs: {
              type: "file",
              accept: "image/*",
              multiple: "",
              hidden: ""
            },
            on: { change: _vm.handleFile }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54f86b16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f86b16","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/monitoring/links/imageUpload/uploadModal.vue
// module id = null
// module chunks = 